export const toCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

export const camelizeKeys = (obj) => {
  const newObj = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[toCamelCase(key)] = obj[key]
    }
  }
  return newObj
}

export const toSnakeCase = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export const convertKeysToSnakeCase = (obj) => {
  const newObj = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[toSnakeCase(key)] = obj[key]
    }
  }
  return newObj
}
